import { Component, ElementRef, OnInit, ViewChild, ViewEncapsulation, Inject } from '@angular/core';
import { DOCUMENT } from '@angular/common';
import { Storage, ref, listAll, deleteObject, uploadBytesResumable, getDownloadURL } from '@angular/fire/storage'; // Updated Storage import + added functions
import { Auth, authState, User } from '@angular/fire/auth'; // Updated Auth import + added functions
import { Auth as FirebaseSDKAuth } from '@firebase/auth'; // Import underlying Auth type for casting
import { DialogService, DynamicDialogConfig, DynamicDialogRef } from 'primeng/dynamicdialog';
import { Dome } from 'src/app/_models/dome';
import { HttpClient } from '@angular/common/http';
import { NgxQrcodeElementTypes, NgxQrcodeErrorCorrectionLevels } from '@techiediaries/ngx-qrcode';
import { environment } from 'src/environments/environment';
import { Config } from 'src/app/_models/config';
import { Firestore, doc, docData, deleteDoc, FirestoreDataConverter, DocumentData, QueryDocumentSnapshot, SnapshotOptions, collection, addDoc, updateDoc, serverTimestamp, Timestamp } from '@angular/fire/firestore'; // Updated Firestore import + added functions
import { map, filter } from 'rxjs/operators' // Added filter
import { SortFeaturesPipe } from '../../_pipes/sort-features-pipe';
import { AnalyticsService } from 'src/app/services/analytics.service';
import { ConfirmationService, MessageService, MenuItem } from 'primeng/api'; // Added MenuItem
import { SharedService } from 'src/app/services/shared.service';
import { ARStoryOption, AudioText } from 'src/app/_models/ARStoryOption';
import { Md5 } from 'ts-md5/dist/md5';
import { Router } from '@angular/router';
import { UtilsService } from 'src/app/_services/utils.service';
import { FileUploadService } from 'src/app/_services/file-upload.service';
import { of, Observable } from 'rxjs';

@Component({
  selector: 'app-domes-create',
  templateUrl: './domes-create.component.html',
  styleUrls: ['./domes-create.component.scss'],
  encapsulation: ViewEncapsulation.None,
  providers: [SortFeaturesPipe]
})
export class DomesCreateComponent implements OnInit {

  // Define the FirestoreDataConverter for Config (similar to shared.service.ts)
  private configConverter: FirestoreDataConverter<Config> = {
    toFirestore(config: Config): DocumentData {
      return config; // Assuming direct write is okay
    },
    fromFirestore(
      snapshot: QueryDocumentSnapshot<DocumentData>,
      options: SnapshotOptions
    ): Config {
      const data = snapshot.data(options)!;
      return { id: snapshot.id, ...data } as Config;
    }
  };

  @ViewChild("menuDisplay") menuDisplay: ElementRef;
  @ViewChild("deleteDisplay") deleteDisplay: ElementRef;
  @ViewChild("contextMenu") contextMenu: ElementRef;
  @ViewChild("qrDisplay") qrDisplay: ElementRef;
  @ViewChild("uploadPopup") uploadPopup: ElementRef;
  @ViewChild('accountMenu') accountMenu: any; // Add ViewChild for account menu
  @ViewChild('accountBtn') accountBtn: ElementRef; // Add ViewChild for account button

  public clientId: string;
  private projectId: string;

  files: any[] = [];

  uploadedFiles: any[] = [];
  deleteFiles: string[] = [];

  originalDome: Dome;

  public isUpdate: boolean = false;
  published: boolean;
  domeName: string;

  private user: User | null; // Use User type from @angular/fire/auth
  public role: string;

  public _config: Config;

  public elementType = NgxQrcodeElementTypes.URL;
  public correctionLevel = NgxQrcodeErrorCorrectionLevels.HIGH;
  public qrUrl = '';

  maxAudioSize: number = 10000000;

  features: Record<string, any> = [
    { id: "Gallery", oid: "Gallery", name: "Gallery", image: "assets/images/Icons/Gallery.svg", enabled: false, index: 0, duplicatable: false, deletable: false, displayable: false, canOpen: false, activated: true, canAdd: true, value: "" },
    { id: "Video", oid: "Video", name: "Video", image: "assets/images/Icons/Video.svg", enabled: true, index: 1, duplicatable: true, deletable: false, displayable: true, canOpen: false, activated: true, canAdd: true, value: "" },
    { id: "Website", oid: "Website", name: "Website", image: "assets/images/Icons/Web.svg", enabled: false, index: 4, duplicatable: true, deletable: false, displayable: false, canOpen: false, activated: true, canAdd: true, value: "" },
    { id: "Phone", oid: "Phone", name: "Phone", image: "assets/images/Icons/Phone.svg", enabled: false, index: 5, duplicatable: true, deletable: false, displayable: false, canOpen: false, activated: true, canAdd: true, value: "" },
    { id: "App Store", oid: "AppStore", name: "App Store", image: "assets/images/Icons/Web.svg", enabled: false, index: 10, duplicatable: false, deletable: false, displayable: false, canOpen: false, activated: true, canAdd: true, value: "" },
    { id: "AR Story", oid: "InteractiveAR", name: "AR Story", image: "assets/images/Icons/AR.svg", enabled: false, index: 11, duplicatable: false, deletable: false, displayable: true, canOpen: false, activated: true, canAdd: true, value: "" },
    { id: "Blog", oid: "Blog", name: "Information", image: "assets/images/Icons/Info.svg", enabled: false, index: 13, duplicatable: true, deletable: false, displayable: false, canOpen: false, activated: true, canAdd: true, value: "" },
    { id: "Colour", oid: "Colour", name: "Colour", image: "assets/images/Icons/Gallery.svg", enabled: false, index: 14, duplicatable: false, deletable: false, displayable: false, canOpen: false, activated: true, canAdd: false, value: "" },
    { id: "Logo", oid: "Logo", name: "Logo", image: "assets/images/Icons/Gallery.svg", enabled: false, index: 15, duplicatable: false, deletable: false, displayable: false, canOpen: false, activated: true, canAdd: false, value: "" },
    { id: "Audio", oid: "Audio", name: "Audio", image: "assets/images/Icons/AR.svg", enabled: true, index: 16, duplicatable: true, deletable: false, displayable: true, canOpen: true, activated: true, canAdd: true, value: "" },
    { id: "Navigation", oid: "Navigation", name: "Navigation", image: "assets/images/Icons/Map.svg", enabled: false, index: 17, duplicatable: false, deletable: false, displayable: true, canOpen: false, activated: true, canAdd: true, value: "" }
  ];

  featurePaths = [
    { id: "Gallery", path: "gallery", canOpen: true },
    { id: "Video", path: "video", canOpen: true },
    { id: "Map", path: undefined, canOpen: true },
    { id: "Information", path: "info", canOpen: true },
    { id: "Website", path: "website", canOpen: false },
    { id: "Phone", path: undefined, canOpen: false },
    { id: "AR", path: undefined, canOpen: true },
    { id: "Competition", path: "competition", canOpen: true },
    { id: "GPS", path: undefined, canOpen: true },
    { id: "Journey", path: "journey", canOpen: true },
    { id: "AppStore", path: undefined, canOpen: true },
    { id: "Interactive", path: undefined, canOpen: true },
    { id: "InteractiveAR", path: undefined, canOpen: true },
    { id: "Blog", path: undefined, canOpen: true },
    { id: "Colour", path: undefined, canOpen: false },
    { id: "Logo", path: undefined, canOpen: false },
    { id: "Audio", path: "audio", canOpen: true },
    { id: "Navigation", path: "navigation", canOpen: true }
  ];

  models = [
    { id: "14", name: "Ambassador", isCustom: false, modelSize: { x: 0.64309, y: 1.83132, z: 0.477865} },
    { id: "15", name: "Santa Ambassador", isCustom: false, modelSize: { x: 0.64309, y: 1.83132, z: 0.477865} },
    { id: "16", name: "Green Hat Santa Ambassador", isCustom: false, modelSize: { x: 0.64309, y: 1.83132, z: 0.477865} }

  ];
  
  voices = [
    { id: "onwK4e9ZLuTAKqWW03F9", name: "Daniel - middle aged male, British", file: "assets/audio/Daniel.mp3", gender: 'Male' },
    { id: "BgdB8LkxV25DmnTgabLx", name: "Evan - showbiz, excited, happy", file: "assets/audio/Daniel.mp3", gender: 'Male' },
    { id: "yl2ZDV1MzN4HbQJbMihG", name: "Alex - Young American Male", file: "assets/audio/Daniel.mp3", gender: 'Male' },
    { id: "bIHbv24MWmeRgasZH58o", name: "Will - Young Male, American, Friendly, Social media", file: "assets/audio/Daniel.mp3", gender: 'Male' },
    { id: "MF3mGyEYCl7XYWbV9V6O", name: "Elli - young female, American", file: "assets/audio/Elli.mp3", gender: 'Female' },
    { id: "g5CIjZEefAph4nQFvHAz", name: "Ethan - young male, American, whispered", file: "assets/audio/Ethan.mp3", gender: 'Male' },
    { id: "GBv7mTt0atIp3Br8iCZE", name: "Thomas - young male, American", file: "assets/audio/Jeremy.mp3", gender: 'Male' },
    { id: "zrHiDhphv9ZnVXBqCLjz", name: "Mini - young female, English-Swedish", file: "assets/audio/Mimi.mp3", gender: 'Female' },
    { id: "zcAOhNBS3c14rBihAFp1", name: "Giovanni - young male, English-Italian", file: "assets/audio/Giovanni.mp3", gender: 'Male' },
    { id: "z9fAnlkpzviPz146aGWa", name: "Glinda - middle aged female, American", file: "assets/audio/Glinda.mp3", gender: 'Female' },
    { id: "ZQe5CZNOzWyzPSCn5a3c", name: "James - old male, Australian", file: "assets/audio/James.mp3", gender: 'Male' },
    { id: "XB0fDUnXU5powFXDhCwa", name: "Charlotte - middle aged female, English-Swedish", file: "assets/audio/Charlotte.mp3", gender: 'Female' },
    { id: "IKne3meq5aSn9XLyUdCD", name: "Charlie - middle aged male, Australian", file: "assets/audio/Charlie.mp3", gender: 'Male' },
    { id: "D38z5RcWu1voky8WS1ja", name: "Fin - old male, Irish", file: "assets/audio/Fin.mp3", gender: 'Male' },
    { id: "nglTNunDbXXmiji2c0er", name: "Rashid - old male, African", file: "assets/audio/Rashid.mp3", gender: 'Male' },
    { id: "2Qm71sRytLTha5j1MF8q", name: "Mampai - middle aged female, African", file: "assets/audio/Mampai.mp3", gender: 'Female' },
    { id: "CxUztP58160dJGJuZugP", name: "Lilavati - middle aged female, Indian", file: "assets/audio/Lilavati.mp3", gender: 'Female' },
    { id: "sIUVVVecd9vlpnXtyr8U", name: "Paddington - old male, British", file: "assets/audio/Paddington.mp3", gender: 'Male' },
    { id: "CYw3kZ02Hs0563khs1Fj", name: "Dave - male, British, Essex", file: "assets/audio/Dave.mp3", gender: 'Male' },
    { id: "kQKcE8pMjWk4bNy7dnYv", name: "Alice - young female, British", file: "assets/audio/Alice.mp3", gender: 'Female' },
    { id: "qFEnPO5LrdZ9gkzZ060V", name: "Jennifer - young female, British", file: "assets/audio/Jennifer.mp3", gender: 'Female' },
    { id: "4zDsWfgtAP9O9F9kJlUk", name: "Grace - young female, British", file: "assets/audio/Grace.mp3", gender: 'Female' },
  ];

  animations = [
    { id: "Talking_1", label: "Talking 1" },
    { id: "Talking_2", label: "Talking 2" },
    { id: "Talking_3", label: "Talking 3" },
    { id: "HipHop", label: "HipHop" },
    { id: "Nervous", label: "Nervous" },
    { id: "Happy", label: "Happy" },
    { id: "Sad", label: "Sad" },
    { id: "Breathing", label: "Breathing" },
    { id: "HandRaising", label: "Hand Raising" },
    { id: "HandsForward", label: "Hands Forward" },
    { id: "StandingGreeting", label: "Standing Greeting" },
    { id: "Waving", label: "Waving" },
    { id: "Clapping", label: "Clapping" },
    { id: "SalsaDancing", label: "Salsa Dancing" },
    { id: "Pointing", label: "Pointing" },
  ]

  rootElement: ARStoryOption = new ARStoryOption();

  progress: number;
  currentAudio: string;

  public saving: boolean;

  colourFeature: any;
  logoFeature: any;

  maxVideoSize: number = 50000000;
  maxImageSize: number = 10000000;

  geo = { latitude: 0.00, longitude: 0.00 };

  addedFeatures: Array<any> = [];
  addFeatureShowing: boolean;
  selectedFeature: any;

  public domes : Dome[]
  public observableDomesForNavigation: Observable<Dome[]>;


  elementCount: number;
  createdCount: number;

  public accountMenuItems: MenuItem[]; // Add accountMenuItems property


  constructor(public dialogService: DialogService,
    public ref: DynamicDialogRef,
    public config: DynamicDialogConfig,
    private storage: Storage, // Corrected type and name
    public auth: Auth, // Corrected type and name
    private firestore: Firestore, // Corrected type and name
    private http: HttpClient,
    @Inject(DOCUMENT) document: Document,
    public sort: SortFeaturesPipe,
    private myanalytics: AnalyticsService,
    private sharedService: SharedService,
    private messageService: MessageService,
    private confirmationService: ConfirmationService,
    private router: Router,
    private utils: UtilsService,
    private fileUploadService: FileUploadService) {

    this.sharedService.role$.subscribe(role =>{
      this.role = role
    })
    // Constructor injection handles initialization, no need for explicit check here
    authState(this.auth as FirebaseSDKAuth).subscribe(user => { // Cast Auth to underlying SDK type
      this.user = user;
    });

    if (config.data?.messageService) {
      this.messageService = config.data.messageService;
    }

    this.clientId = config.data.clientId;
    this.projectId = config.data.projectId;

    // Constructor injection handles initialization, no need for explicit check here
    const configDocRefUntyped = doc(this.firestore, 'config', 'Config');
    const configDocRefTyped = configDocRefUntyped.withConverter(this.configConverter);
    docData<Config>(configDocRefTyped).pipe(
      filter((config): config is Config => !!config), // Filter undefined
      map((value) => {
      this._config = value;

      this.features.forEach(feature => {
        switch (feature.oid) {
          case 'Gallery':
            feature.activated = this._config.features.gallery ?? false;
            break;
          case 'Video':
            feature.activated = this._config.features.video ?? false;
            break;
          case 'Map':
            feature.activated = this._config.features.map ?? false;
            break;
          case 'Information':
            feature.activated = this._config.features.information ?? false;
            break;
          case 'Website':
            feature.activated = true;
            break;
          case 'Phone':
            feature.activated = this._config.features.phone ?? false;
            break;
          case 'AR':
            feature.activated = this._config.features.ar ?? false;
            break;
          case 'Competition':
            feature.activated = this._config.features.competition ?? false;
            break;
          case 'Journey':
            feature.activated = this._config.features.journey ?? false;
            break;
          case 'AppStore':
            feature.activated = this._config.features.appStore ?? false;
            break;
          case 'GPS':
            feature.activated = this._config.features.gps ?? false;
            break;
          case 'Interactive':
            feature.activated = this._config.features.interactive ?? false;
            break;
          case 'InteractiveAR':
            feature.activated = this._config.features.interactiveAR ?? false;
            break;
        }
      });
    })).subscribe();

    this.rootElement = new ARStoryOption();
    this.rootElement.label = "Root";
    this.rootElement.animation = this.animations[0];
  }

  public ngOnInit(): void {
    // Set default animation for root element
    this.rootElement.label = "Root";
    this.rootElement.animation = this.animations[0];

    this.initializeForm();
    if (this.config.data.dome) {
      this.handleUpdateScenario();
    } else {
      this.handleNewScenario();
    }
    this.ensureRequiredFeatures();
    this.initializeAddedFeatures();
    this.domes = this.config.data.domes;
    this.observableDomesForNavigation = of(this.domes || []);
    this.initializeAccountMenu(); // Initialize account menu items
  }

  private initializeAccountMenu(): void {
    // Basic account menu items - adjust as needed
    this.accountMenuItems = [
      {
        label: 'Logout',
        icon: 'pi pi-fw pi-sign-out',
        command: () => {
          // Add logout logic here if needed, e.g., calling an auth service method
          console.log('Logout clicked');
          this.auth.signOut(); // Example logout
          this.router.navigate(['/cognito/sign-in']); // Navigate to login
        }
      }
      // Add other menu items as required
    ];
  }

  public ngAfterViewInit() {
    this.features.forEach(feature => {
      const canOpen = this.featurePaths.find(f => f.id === feature.oid).canOpen;
      feature.canOpen = canOpen;
    });
  }
  
  private initializeForm(): void {
    this.isUpdate = false;
    this.published = true;
  }
  
  private handleUpdateScenario(): void {
    this.isUpdate = true;
    this.originalDome = { ...this.config.data.dome };
    console.log(JSON.stringify(this.originalDome));
    this.setQRUrl();
    this.handleFeatures();
    this.setPublishedStatus();
    this.setStoryAndName();
    this.setGeoLocation();
  }

  
  private setQRUrl(): void {
    this.qrUrl = environment.baseUrl + "?p=" + this.originalDome.id;
  }
  
  private handleFeatures(): void {
    if (this.originalDome.features) {
      this.handleExistingFeatures();
    } 
    this.sort.transform(this.features, "index");
  }
  
  private handleExistingFeatures(): void {
    let tempFeatures = Object.assign([], this.originalDome.features);
    tempFeatures.forEach(oFeature => {
      if (!environment.envfeatures[oFeature.oid]) {
        this.features.splice(this.features.findIndex(feature => feature.oid === oFeature.oid), 1);
      }
    });
    
    this.addedFeatures = tempFeatures.filter(feature => feature.added || feature.enabled);
    if (this.addedFeatures.length > 0) {
      this.selectedFeature = this.addedFeatures[0];
    }
  }
  
  private setPublishedStatus(): void {
    this.published = this.originalDome.published;
  }
  
  private setStoryAndName(): void {
    this.domeName = this.originalDome.name;
  }
  
  private setGeoLocation(): void {
    console.log("calling setGeoLocation");
    console.log(this.originalDome.geo);
    if (this.originalDome.geo.latitude !== 0 && this.originalDome.geo.longitude !== 0) {
      console.log("setting setGeoLocation");
      this.geo = { latitude: this.originalDome.geo.latitude, longitude: this.originalDome.geo.longitude };
    }
    console.log("Finished calling setGeoLocation");
  }

  public resetColours(feature) {
    feature.value.headerColour = '#0D4131';
    feature.value.bgColour = '#EDF0EE';
    feature.value.buttonColour = '#ffffff';
    feature.value.buttonTextColour = '#000000';
  }

  public countElements(element: ARStoryOption) {
    this.elementCount++;

    for (const option of element.options) {
      this.countElements(option);
    }
  }
  
  private handleNewScenario(): void {
    this.features.forEach(oFeature => {
      if (!environment.envfeatures[oFeature.oid]) {
        this.features.splice(this.features.findIndex(feature => feature.oid === oFeature.oid), 1);
      }
    });
  }
  
  private ensureRequiredFeatures(): void {
    this.ensureFeature('Colour');
    this.ensureFeature('Logo');
  }
  
  private ensureFeature(featureOid: string): void {
    const hasFeature = this.addedFeatures.find(f => f.oid === featureOid);
    if (!hasFeature) {
      const feature = this.features.find(f => f.oid === featureOid);
      if (feature) this.addFeature(feature);
    }
  }
  
  private initializeAddedFeatures(): void {
    this.addedFeatures.forEach(feature => {
      switch (feature.oid) {
        case 'Interactive':
        case 'InteractiveAR':
          this.initializeInteractiveFeature(feature);
          break;
        case 'Colour':
          this.initializeColourFeature(feature);
          break;
        case 'Logo':
          this.initializeLogoFeature(feature);
          break;
      }
    });

    //set this.selectedFeature to the first feature that is enabled and displayable
    this.selectedFeature = this.addedFeatures.find(f => f.enabled && f.displayable);
    //if no feature is enabled and displayable, set this.selectedFeature to the first feature that is displayable
    if (!this.selectedFeature) this.selectedFeature = this.addedFeatures.find(f => f.displayable);
  }
  
  private initializeInteractiveFeature(feature: any): void {
    if (this.utils.isEmpty(feature.value)) {
      feature.value = {};
      feature.value.root = structuredClone(this.rootElement);
      feature.interactiveModel = this.models[0];
      feature.interactiveVoice = this.voices[0];
      feature.selectedElement = feature.value.root;
      this.checkElementIds(feature.value.root);
    }
  }
  
  private initializeColourFeature(feature: any): void {
    feature.enabled = true;
    this.colourFeature = feature;
    if (this.utils.isEmpty(feature.value)) {
      feature.value = {
        headerColour: '#0D4131',
        bgColour: '#EDF0EE',
        buttonColour: '#ffffff',
        buttonTextColour: '#000000'
      };
    }
  }
  
  private initializeLogoFeature(feature: any): void {
    feature.enabled = true;
    if (this.utils.isEmpty(feature.value)) {
      feature.value = {};
    }
    this.logoFeature = feature;
  }

  private checkElementIds(element: ARStoryOption) {
    if (element.id === undefined)
      element.id = Math.random().toString(36).slice(2, 8);

    element.options.forEach(option => {
      this.checkElementIds(option);
    });
  }

  public async onCreateClicked() {
    this.saving = true;

      
    this.updateInfoFeatures();

    let dome = new Dome();
    dome.features = Object.assign([], this.addedFeatures);
    console.log(dome.features);
    dome.published = this.published;
    dome.name = this.domeName;
    dome.geo = this.geo;

    dome.createdBy = this.user?.uid; // Use optional chaining for user
    dome.id = this.utils.generateId();
    dome.dateCreated = Timestamp.now();

    // Now upload files using the generated dome.id
    await this.uploadInteractiveModels(dome);
    await this.createInteractiveAudio(dome);
    await this.prepareBlogImage(dome);
    await this.uploadAudio(dome);
    await this.uploadVideo(dome);
    await this.uploadImages(dome);

    var returnData: any = {
      dome: Object.assign({}, dome)
    }

    // Return the dome object with the generated ID
    returnData.dome = dome;

    this.ref.close(returnData);

    this.saving = false;
 
  }

  public async onUpdateClicked() {
    this.saving = true;
    this.updateInfoFeatures();

    const dateCreated = this.originalDome.dateCreated;

    // Prepare data for update, ensuring we don't overwrite dateCreated
    const updateData: Partial<Dome> = {
      features: Object.assign([], this.addedFeatures),
      published: this.published,
      name: this.domeName,
      geo: this.geo,
      dateUpdated: Timestamp.now()
    };
    const domeId = this.originalDome.id; // Keep ID for updateDoc reference

    // Upload files first, using the existing domeId
    const tempDomeForUpload = { ...this.originalDome, features: updateData.features }; // Create temp object for upload functions
    await this.uploadInteractiveModels(tempDomeForUpload as Dome);
    await this.createInteractiveAudio(tempDomeForUpload as Dome);
    await this.prepareBlogImage(tempDomeForUpload as Dome);
    await this.uploadAudio(tempDomeForUpload as Dome);
    await this.uploadVideo(tempDomeForUpload as Dome);
    await this.uploadImages(tempDomeForUpload as Dome);
    this.getFilesToDelete(tempDomeForUpload as Dome);

    // Update Firestore document
    // No need to check this.firestore, constructor injection ensures it's available
    // Construct the correct path using clientId and projectId
    const domeDocPath = `clients/${this.clientId}/projects/${this.projectId}/experiences/${domeId}`;
    const domeDocRef = doc(this.firestore, domeDocPath);
    await updateDoc(domeDocRef, updateData);

    // Prepare return data
    const updatedDome = { ...this.originalDome, ...updateData, id: domeId }; // Merge original with updated fields

    updatedDome.dateCreated = dateCreated;

    var returnData: any = {
      dome: updatedDome,
      delete: this.deleteFiles
    }
    this.ref.close(returnData);

    this.saving = false; // Moved saving = false here
  }

  private getFilesToDelete(dome: Dome)
  {
    dome.features.forEach(feature => {
      if(feature.delete)
      {
        feature.delete.forEach(file => {
          this.deleteFiles.push(file)
        });

        delete feature.delete;
      }
    });

    //remove duplicates
    this.deleteFiles = this.deleteFiles.filter(function (v, i, self) {
      return i == self.indexOf(v);
    });
  }

  private async uploadInteractiveModels(dome: Dome) {
    let features = this.addedFeatures.filter(feature => (feature.oid === "Interactive" || feature.oid === "InteractiveAR") && feature.enabled);
    if (features.length > 0) {
      for (const feature of features) {
        if (feature.value.modelFile !== undefined) {
          await this.uploadInteractiveModel(dome.id, feature, feature.value.modelFile);
        }
        await this.uploadElementAnim(dome, feature, feature.value.root);
      };
    }
  }

  async uploadElementAnim(dome: Dome, feature: any, element: ARStoryOption) {
    if (element.animUpload && element.animFile !== undefined && !element.animFile.isUploaded)
      await this.uploadAnimFile(dome.id, element.animFile)

    for (const option of element.options) {
      await this.uploadElementAnim(dome, feature, option);
    };
  }

  private async uploadAnimFile(domeId: string, value: any) {
    try {
      if (value.file && value.isUploaded === false) {
        const filePath = `clients/${this.clientId}/projects/${this.projectId}/experiences/${domeId}/${value.name}`;
        const url = await this.fileUploadService.uploadFile(value.file, filePath);
        value.isUploaded = true;
        delete value.file;
        value.url = url;
      }
    } catch (error) {
      console.error(error);
    }
  }

  private async uploadInteractiveModel(domeId: string, feature: any, value: any) {
    try {
      if (value.file && value.isUploaded === false) {
        const filePath = `clients/${this.clientId}/projects/${this.projectId}/experiences/${domeId}/${value.name}`;
        const url = await this.fileUploadService.uploadFile(value.file, filePath);
        value.isUploaded = true;
        delete value.file;
        value.url = url;
        feature.modelUrl = url;
      }
    } catch (error) {
      console.error(error);
    }
  }

  private async createInteractiveAudio(dome: Dome) {
    let features = this.addedFeatures.filter(feature => (feature.oid === "Interactive" || feature.oid === "InteractiveAR"));
    if (features.length > 0) {
      for (const feature of features) {
        delete feature.selectedElement;
        let root = feature.value.root as ARStoryOption;
        this.elementCount = 0;
        this.createdCount = 0;
        this.countElements(root);
        console.log("Creating " + this.elementCount);
        this.uploadPopup.nativeElement.style.display = "flex";

        await this.createElementAudio(root, feature.interactiveVoice.id, dome);
        this.uploadPopup.nativeElement.style.display = "none";
      };
    }
  }

  private async createElementAudio(arStoryOption: ARStoryOption, voiceId: string, dome: Dome) {

    return new Promise(async (resolve, reject) => {
      let newHash = Md5.hashStr(voiceId + arStoryOption.text) as string;

      if (arStoryOption.audioFile && !arStoryOption.audioFile.isUploaded) {
        this.uploadInteractiveAudioFile(dome.id, arStoryOption.audioFile);
        delete arStoryOption.audioFile.file;
        arStoryOption.audioFile.isUploaded = true;
        console.log("Upload audio for " + arStoryOption.id);
        console.log(arStoryOption);
        this.createdCount++;
        this.progress = 100 * this.createdCount / this.elementCount;
      }
      else if (newHash !== arStoryOption.textHash) {
        arStoryOption.textHash = newHash;
        console.log(JSON.stringify(arStoryOption));
        if (arStoryOption.text != undefined && arStoryOption.text.trim() !== '') {
          await this.createAndUploadAudio(arStoryOption, voiceId, dome.id, arStoryOption.id, () => {
            console.log("Created audio for " + arStoryOption.id);
            this.createdCount++;
            this.progress = 100 * this.createdCount / this.elementCount;
          });
        }
        else {
          this.createdCount++;
          this.progress = 100 * this.createdCount / this.elementCount;
        }
      }
      else {
        this.createdCount++;
        this.progress = 100 * this.createdCount / this.elementCount;
      }

      for (const option of arStoryOption.options) {
        await this.createElementAudio(option, voiceId, dome);
      };

      resolve(0);
    });
  }

  // Changed from arrow function to regular method
  private async createAndUploadAudio(
    storyOption: ARStoryOption,
    selectedVoiceId: string,
    domeId: string, 
    filename: string, 
    callback: () => void
  ): Promise<void> { // Return void, just await the promise
    this.currentAudio = filename;

    return new Promise((resolve, reject) => { // Keep promise for internal async logic
      console.log("Creating audio with timestamps - " + selectedVoiceId);
      
      const json = {
        'text': storyOption.text, // Now using text from storyOption
        'model_id': 'eleven_multilingual_v2',
        'voice_settings': {
          'stability': 0.9,
          'similarity_boost': 0,
          'style': 0.9,
          'use_speaker_boost': true
        }
      };
  
      const url = `https://api.elevenlabs.io/v1/text-to-speech/${selectedVoiceId}/with-timestamps`;
      
      const headers = {
        'content-type': 'application/json',
        'xi-api-key': 'add8193c13e1b240d9876329a1cd9907'
      };
  
      interface ElevenLabsResponse {
        audio_base64: string;
        alignment: {
          characters: string[];
          character_start_times_seconds: number[];
          character_end_times_seconds: number[];
        }
      }
  
      this.http.post<ElevenLabsResponse>(url, json, { headers: headers }).subscribe(
        response => {
          // Convert base64 audio to blob
          const audioBlob = this.base64ToBlob(
            response.audio_base64,
            'audio/mpeg'
          );
  
          // Update the ARStoryOption with  alignment data
          if (!storyOption.audioText) {
            storyOption.audioText = new AudioText();
          }
          storyOption.audioText.characters = response.alignment.characters;
          storyOption.audioText.characterStartTimes = response.alignment.character_start_times_seconds;
          storyOption.audioText.characterEndTimes = response.alignment.character_end_times_seconds;
          storyOption.audioText = Object.assign({}, storyOption.audioText);
  
          // Upload audio file
          const filePath = `clients/${this.clientId}/projects/${this.projectId}/experiences/${domeId}/el-${filename}.mpga`;
          console.log(filePath);
          const storageRef = ref(this.storage, filePath); // Use ref function

          // Use uploadBytesResumable
          const uploadTask = uploadBytesResumable(storageRef, audioBlob, { contentType: 'audio/mpeg' });

          // Wait for upload completion
          uploadTask.then(snapshot => {
              console.log("Audio Uploaded");
              callback();
              resolve(); // Resolve the void promise
          }).catch(error => {
              console.error("Error uploading audio:", error);
              reject(error);
          });
        },
        error => {
          console.error("Error generating audio:", error);
          reject(error);
        }
      );
    });
  }

  private base64ToBlob(base64: string, contentType: string): Blob {
    const byteCharacters = atob(base64);
    const byteArrays = [];
  
    for (let offset = 0; offset < byteCharacters.length; offset += 512) {
      const slice = byteCharacters.slice(offset, offset + 512);
      const byteNumbers = new Array(slice.length);
      
      for (let i = 0; i < slice.length; i++) {
        byteNumbers[i] = slice.charCodeAt(i);
      }
      
      const byteArray = new Uint8Array(byteNumbers);
      byteArrays.push(byteArray);
    }
  
    return new Blob(byteArrays, { type: contentType });
  }

  private async uploadInteractiveAudioFile(domeId: string, value: any) {
    try {
      if (value.file && value.isUploaded === false) {
        const filePath = `clients/${this.clientId}/projects/${this.projectId}/experiences/${domeId}/${value.name}`;
        await this.fileUploadService.uploadFile(value.file, filePath);
        value.isUploaded = true;
        delete value.file;
      }
    } catch (error) {
      console.error(error);
    }
  }

  private async uploadAudio(dome: Dome) {
    let features = this.addedFeatures.filter(feature => feature.oid === "Audio");
    if (features.length > 0) {
      for (const feature of features) {
        if (feature.value.items !== undefined && feature.value.items.length > 0) {
          for (const item of feature.value.items) {
            await this.uploadAudioFile(dome.id, feature, item);
          }
        }
      };
    }
  }

  private async uploadAudioFile(domeId: string, feature: any, value: any) {
    try {
      if (value.file && value.isUploaded === false) {
        const filePath = `clients/${this.clientId}/projects/${this.projectId}/experiences/${domeId}/${value.name}`;
        const url = await this.fileUploadService.uploadFile(value.file, filePath);
        value.isUploaded = true;
        delete value.file;
        value.url = url;
      }
    } catch (error) {
      console.error(error);
    }
  }

  private async uploadVideo(dome: Dome) {
    let features = this.addedFeatures.filter(feature => feature.oid === "Video");
    if (features.length == 0) return;
    for (const feature of features) {
      if (feature.value === undefined ) return;
      await this.uploadVideoFile(dome.id, feature.value);
    };
  }

  private async uploadVideoFile(domeId: string, value: any) {
    try {
      if (value.file && value.isUploaded === false) {
        const filePath = `clients/${this.clientId}/projects/${this.projectId}/experiences/${domeId}/${value.name}`;
        const url = await this.fileUploadService.uploadFile(value.file, filePath);
        value.isUploaded = true;
        delete value.file;
        value.url = url;
      }
    } catch (error) {
      console.error(error);
    }
  }

  private async uploadImages(dome: Dome) {
    let features = this.addedFeatures.filter(feature => feature.oid === "Gallery" || feature.oid === "Logo");
    if (features.length == 0) return;
    for (const feature of features) {
      if (feature.value === undefined ) return;
      await this.uploadImageFile(dome.id, feature.value);
    };
  }

  private async uploadImageFile(domeId: string, value: any) {
    try {
      if (!value) return;
      const values = Array.isArray(value) ? value : [value];
      for (const file of values) {
        if (file && file.isUploaded === false) {
          const filePath = `clients/${this.clientId}/projects/${this.projectId}/experiences/${domeId}/${file.name}`;
          const url = await this.fileUploadService.uploadFile(file.file, filePath);
          file.isUploaded = true;
          delete file.file;
          URL.revokeObjectURL(file.url);
          file.url = url;
        }
      }
    } catch (error) {
      console.error(error);
    }
  }

  private updateInfoFeatures() {
    let features = this.addedFeatures.filter(feature => feature.oid === "Information" && feature.enabled);
    features.forEach(feature => {
      const ele = document.getElementById(feature.id);
      feature.value = ele.innerHTML;
    });
  }

  public onCancelClicked() {
    if (this.originalDome) {
      this.myanalytics.logEvent("button_click", { button: "UpdateCancelled", user: this.user?.uid, id: this.originalDome.id }); // Use uid
    }
    else {
      this.myanalytics.logEvent("button_click", { button: "CreateCancelled", user: this.user?.uid }); // Use uid
    }
    this.ref.close();
  }

  public async removeDome(dome: Dome) { // Make async
    this.myanalytics.logEvent("button_click", { button: "DeleteClicked", user: this.user?.uid, id: dome.id }); // Use uid
    try {
      const domeStorageRef = ref(this.storage, `clients/${this.clientId}/projects/${this.projectId}/experiences/${dome.id}`); // Use ref function
      const listResult = await listAll(domeStorageRef); // Use listAll function
      
      // Delete all items in the folder
      const deletePromises = listResult.items.map(itemRef => deleteObject(itemRef)); // Use deleteObject
      await Promise.all(deletePromises);
      
      // Delete subfolders (if any - listAll doesn't list recursively by default)
      // Consider recursive deletion if needed
      
      // Delete Firestore document
      // No need to check this.firestore, constructor injection ensures it's available
      const domeDocRef = doc(this.firestore, `clients/${this.clientId}/projects/${this.projectId}/experiences/${dome.id}`); // Use doc function
      await deleteDoc(domeDocRef); // Use deleteDoc function

      this.ref.close();
    } catch (error) {
      console.error("Error removing dome:", error);
      // Optionally show an error message to the user
    }
  }

  public toggleFeature(feature: any, event: any) { // Add types
    feature.enabled = !feature.enabled;
  }

  public togglePublish() {
    this.published = !this.published;
    this.myanalytics.logEvent("button_click", { button: "publishClicked", published: this.published, id: this.originalDome?.id, user: this.user?.uid }); // Use uid
  }

  public hideMenu() {
    this.menuDisplay.nativeElement.style.display = "none";
  }

  public showDeleteConfirm() {
    if (this.originalDome !== undefined)
      this.deleteDisplay.nativeElement.style.display = "flex";
    else
      this.ref.close();
  }

  public hideDeleteConfirm() {
    this.deleteDisplay.nativeElement.style.display = "none";
  }

  public showQR(feature: any) { // Add type
    if (feature.canOpen) {
      const path = this.featurePaths.find(f => f.id === feature.oid).path;
      if (path !== undefined) {
        const url = environment.baseUrl + path + "/" + feature.id + "?p=" + this.originalDome.id + "&r=d";
        this.qrUrl = url;
        this.qrDisplay.nativeElement.style.display = "flex";
      }
      else {
        if (feature.oid === "AR") {
          const url = environment.arUrl + this.originalDome.id + "&r=d&m=ar";
          this.qrUrl = url;
          this.qrDisplay.nativeElement.style.display = "flex";
        }
        else if (feature.oid === "Map") {
          const url = environment.arUrl + this.originalDome.id + "&r=d&m=map";
          this.qrUrl = url;
          this.qrDisplay.nativeElement.style.display = "flex";
        }
      }
    }
  }

  public hideQR() {
    this.qrDisplay.nativeElement.style.display = "none";
  }

  public downloadQR() {
    this.myanalytics.logEvent("button_click", { button: "DownloadClicked", user: this.user?.uid, id: this.originalDome.id }); // Use uid
    setTimeout(() => {
      const fileNameToDownload = this.originalDome.id;
      const base64Img = document.getElementById("qrCode2").getElementsByClassName('bshadow')[0].children[0]['src'];
      fetch(base64Img)
        .then(res => res.blob())
        .then((blob) => {
          const url = window.URL.createObjectURL(blob);
          const link = document.createElement('a');
          link.href = url;
          link.download = fileNameToDownload;
          link.click();
        })
    }, 1000);
  }

  private prepareBlogImage(dome: Dome) {
    return new Promise(async (resolve, reject) => {
      let features = this.addedFeatures.filter(feature => (feature.oid === "Blog") && feature.enabled);
      if (features.length > 0) {
        for (const feature of features) {
          console.log(feature);
          this.uploadPopup.nativeElement.style.display = "flex";

          let blogItems = feature.value.blogItems ?? [];
          for (const item of blogItems) {
            console.log(item.type);
            if (item.type === "image") {
              let images = item.images;
              for (const image of images) {
                console.log("Upload image");
                await this.uploadBlogImage(dome.id, item, image);
              }
            }
          }
        }
      }
      this.uploadPopup.nativeElement.style.display = "none";
      resolve(0);
    });
  }

  private async uploadBlogImage(domeId: string, item: any, image: any) {
    try {
      if (image.file && image.isUploaded === false) {
        const filePath = `${domeId}/${item.id}/${image.name}`;
        const url = await this.fileUploadService.uploadFile(image.file, filePath);
        image.isUploaded = true;
        delete image.file;
        URL.revokeObjectURL(image.url);
        image.url = url;
      }
    } catch (error) {
      console.error(error);
    }
  }

  public goBack(event: Event) {
    this.confirmationService.confirm({
      header: 'Unsaved Changes',
      message: "Close without saving?",
      icon: 'pi pi-exclamation-triangle',
      accept: () => this.ref.close(),
    });
  }

  public showExperienceQR() {
    this.qrUrl = environment.baseUrl + "?p=" + this.originalDome.id;
    this.qrDisplay.nativeElement.style.display = "flex";
  }

  public openExperience() {
    this.myanalytics.logEvent("button_click", { button: "PreviewExperienceClicked", user: this.user?.uid, id: this.originalDome.id, name: this.originalDome.name }); // Use uid
    const url = environment.baseUrl + "?p=" + this.originalDome.id;
    window.open(url, '_blank').focus();
  }

  public openUrl(url: string) { // Add type
    this.myanalytics.logEvent("button_click", { button: "OpenUrl", user: this.user?.uid, url: url }); // Use uid
    window.open(url, '_blank').focus();
  }

  // Add the missing manageUser method
  public manageUser(event: Event): void {
    if (this.accountMenu && this.accountBtn) {
      this.accountMenu.toggle(event); // Use the p-menu toggle method
    } else {
      console.error('Account menu or button not found');
    }
  }

  public manageAccount() {
    // This method is likely called by the 'Manage Account' menu item now
    // Keep the confirmation logic if direct navigation is still possible elsewhere
    // Or simplify if only called from the menu command
    this.confirmationService.confirm({
      target: event.target,
      message: "You will lose any unsaved changes.",
      icon: 'pi pi-exclamation-triangle',
      accept: () => {
        this.ref.close();
        this.router.navigate(['user-manage']);
      }
    });
  }

  public onChangeLogo(feature: any, event: any) { // Add type
    console.log("onChange");
    const file: File = event.target.files[0];

    if (file) {
      this.myanalytics.logEvent("button_click", { button: "experienceLogo", user: this.user?.uid }); // Use uid
      if (file.type.startsWith('image')) {
        if(feature.value === "")
          feature.value = {};

        if(feature.value.isUploaded === true)
        {
          if(this.utils.isEmpty(feature.delete)) {
            feature.delete = [];
          }
          feature.delete.push(feature.value.name + "." + feature.value.contentType);
        }

        feature.value = {
          name: file.name,
          url: URL.createObjectURL(file),
          size: file.size,
          type: 'image',
          file: file,
          isUploaded: false
        };
      }
    }
  }

  public updateFeature(updatedFeature: any) {
    const index = this.addedFeatures.findIndex(f => f.id === updatedFeature.id);
    if (index !== -1) {
      this.addedFeatures[index] = updatedFeature;
    }
  }

  public deleteFeature(feature: any) { // Add type
    const index = this.addedFeatures.indexOf(feature, 0);
    if (index > -1) {
      this.addedFeatures.splice(index, 1);
    }
    this.selectedFeature = index > 0 ? this.addedFeatures[index - 1] : undefined;
  }

  public addFeature(feature: any) {
    // Check if the feature can be duplicated based on oid and duplicatable flag
    if (!feature.duplicatable && this.addedFeatures.some(f => f.oid === feature.oid)) {
      this.messageService.add({ severity: 'error', summary: 'Error', detail: 'Cannot add more of this type' });
      return;
    }
  
    // Generate a unique ID
    let id = feature.id;
    let count = 0;
  
    while (this.addedFeatures.some(f => f.id === id)) {
      count++;
      id = `${feature.id}_${count}`;
    }
  
    // Get next available index
    const index = Math.max(0, ...this.addedFeatures.map(f => f.index)) + 1;
  
    // Create feature clone
    const canOpen = this.featurePaths.find(f => f.id === feature.oid)?.canOpen;
    const clone: Record<string, any> = {
      id,
      oid: feature.oid,
      name: feature.name,
      image: feature.image,
      enabled: feature.enabled,
      activated: feature.activated,
      displayable: feature.displayable,
      canOpen,
      canAdd: feature.canAdd,
      index,
      added: true,
      value: null
    };
  
    // Handle interactive features
    if (feature.oid === "Interactive" || feature.oid === "InteractiveAR") {
      clone.value = { root: structuredClone(this.rootElement) };
      clone.interactiveModel = this.models[0];
      clone.interactiveVoice = this.voices[0];
      clone.selectedElement = feature.value.root;
      this.checkElementIds(clone.value.root);
    }
  
    // Add the new feature and handle post-add logic
    this.addedFeatures.push(clone);
    this.addFeatureShowing = false;
  
    if (canOpen) {
      this.selectedFeature = clone;
    }
  }
}
